import { render, staticRenderFns } from "./ExamplesMenu.vue?vue&type=template&id=36662d27&"
import script from "./ExamplesMenu.vue?vue&type=script&lang=js&"
export * from "./ExamplesMenu.vue?vue&type=script&lang=js&"
import style0 from "./ExamplesMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports